module.exports = "/images/child-safety@3x.png?4c93987062d6b7a17f06689a9fff2ba2";